import { InferType, boolean, number, object, string } from "yup";

export const DocumentationSchema = object({
    id: number().notRequired(),
    active: boolean(),
    html: string(),
    pathname: string(),
});

export const defaultDocumentation = {
    active: true,
    html: "",
    pathname: "/",
};

export type Documentation = InferType<typeof DocumentationSchema>;
